export class reportMenu {
  Reportes: Reportes[];

  constructor() {
    this.Reportes = [];
  }
}

export class Reportes {
  Id_Cnsc_TipoReporte: any;
  Nom_TipoReporte: string;

  constructor() {
    this.Id_Cnsc_TipoReporte = null;
    this.Nom_TipoReporte = '';
  }
}
